import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { Provider } from 'react-redux';
import store from 'data/store';
import { exchangeCodeForToken, getKeycloakLoginUrl } from './services';
import AppWrapper from './App';

// Function to handle Keycloak Redirect and loginToken from URL
const handleKeycloakRedirect = async (): Promise<string | null> => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('session_state');
  const loginToken = urlParams.get('loginToken'); // Check for loginToken in URL

  // If loginToken exists, redirect to /chat
  if (loginToken) {
    localStorage.setItem('matrixLoginToken', loginToken);
    console.log('🔍 Found loginToken in URL, redirecting to /chat...');
    window.location.href = `/chat`;
    return null; // Don't continue further if loginToken is found
  }

  localStorage.setItem('selectedSidebarTab', 'dashboard');
  if (code && state) {
    try {
      const token = await exchangeCodeForToken(code);
      console.log('token', token);

      if (token) {
        // Save the token to sessionStorage
        sessionStorage.setItem('authToken', token);

        // Clear query parameters from the URL
        window.history.replaceState({}, document.title, window.location.pathname);

        return token;
      } else {
        console.error('Token is null or undefined');
        return null;
      }
    } catch (error) {
      console.error('Error exchanging code for token:', error);
      return null; // Do not redirect to Keycloak on error
    }
  } else {
    // Check if there's an existing token in sessionStorage
    const existingToken = sessionStorage.getItem('authToken');
    if (!existingToken) {
      // Redirect to Keycloak login if no token exists
      const keycloakLoginUrl = getKeycloakLoginUrl();
      window.location.href = keycloakLoginUrl;
    }
    return existingToken; // existingToken can be null
  }
};

(async () => {
  const token = await handleKeycloakRedirect();
  if (token) {
    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    root.render(
      <Provider store={store}>
        <AppWrapper token={token} />
      </Provider>
    );
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
